import { faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import TextField from '../../../components/TextField'
import ModalCustomized from '../../../components/Modal/Modal'
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas'
import RichTextEditor from '../../../components/RichTextEditor'

export default function ModeloDeEnviorEmail({
    editavel = true, 
    listaVariaveisSistema,
    modeloEmail, 
    setModeloEmail,
    onChange, 
    errors, 
    isModalListaVariaveis, 
    setIsModalListaVariaveis, 
    title = "Adicionar modelo de e-mail"
  }) {
    const toggleModalListaVariaveis = () => setIsModalListaVariaveis(!isModalListaVariaveis);

     //Cabeçalhos que a tabela terá
    const headersListaDeVariaveis = [
        { value: "Código", objectValue: "codigo", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" }
    ];

    //Função que salva as imagens base64 adicionadas no conteudo html
    const setImage = (base64, e) => {
        setModeloEmail({
            ...modeloEmail,
            [e.target.value]:e.target.value,
            imagensConteudo: [...modeloEmail.imagensConteudo ? modeloEmail.imagensConteudo : [], base64]
        })
    }

    return (
        <>
            <Row>
                {isModalListaVariaveis &&
                    <ModalCustomized
                        toggle={toggleModalListaVariaveis}
                        isOpen={isModalListaVariaveis}
                        btnClose={toggleModalListaVariaveis}
                        title={"Lista de variáveis"}
                    >
                        <TabelaListagemFichas
                            options={{ print: false, search: true, pagination: true }}
                            headers={headersListaDeVariaveis}
                            items={listaVariaveisSistema}
                        />
                    </ModalCustomized>
                }
            </Row>

            <Row className='d-flex align-items-center justify-content-between mb-4'>
                <Col md="6" lg="6" className='text-start'>
                    <h5 className='text-secondary'>{title}</h5>
                </Col>
                <Col md="6" lg="6" className={`text-end ${editavel ? "" : "d-none"}`}>
                    <Button
                        color='dark'
                        className='text-white fw-bold'
                        onClick={() => setIsModalListaVariaveis(true)}
                    >
                        <FontAwesomeIcon icon={faFileAlt} />  Visualizar lista de variáveis
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col md="12" lg="12">
                    <TextField
                        label="* Assunto"
                        name={"assunto"}
                        onChange={onChange}
                        value={modeloEmail.assunto}
                        invalid={!!errors.assunto}
                        maxLength={100}
                        disabled={!editavel}
                    />
                </Col>
            </Row>
             
            <Row className='mt-2'>
                <Col md="12" lg="12">
                    <RichTextEditor
                        name={"conteudo"}
                        saveImage={setImage}
                        value={modeloEmail.conteudo}
                        onChange={onChange}
                        invalid={!!errors.conteudo}
                    />
                </Col>
            </Row>
        </>
    )
}
